import * as React from 'react';
import { api } from 'services';
import type { CreateServiceOrderPayload } from 'contracts/service-orders';

export const useCreateServiceOrder = () => {
  const createServiceOrder = React.useCallback(async (data: CreateServiceOrderPayload) => {
    await api.post('/inventory/service-orders', data);
  }, []);

  return {
    createServiceOrder
  }
}